import { useConcurso } from '../../../../../providers/ConcursoProvider';
import CargaActoAdministrativo from '../../CargaActoAdministrativo/CargaActoAdministrativo';
import CargaDictamen from '../../CargaDictamen';
import PrimerActa from '../../ConfeccionPrimerActa';
import DesignacionVeedores from '../../DesignacionVeedores';
import Publicar from '../../Publicar/Publicar';
import ConcursoPublicadoCC from './ConcursoPublicadoCC';

const TramitarCC = () => {
  const concurso = useConcurso();
  const etapa = concurso.etapaLlamadoConcurso.idEtapaLlamadoConcurso;

  const numeroDeEtapa = (etapa) => {
    if (etapa > 7 && etapa <= 20) {
      return etapa;
    }
  };

  switch (etapa) {
    case 3:
      return <DesignacionVeedores concurso={concurso} />;
    case 4:
      return <CargaDictamen concurso={concurso} />;
    case 5:
      return <PrimerActa />;
    case 6:
      return <CargaActoAdministrativo />;
    case 7:
      return <Publicar />;
    case numeroDeEtapa(etapa):
      return <ConcursoPublicadoCC etapa={etapa} />;
    default:
      return <div>No se reconoce el estado del concurso activo</div>;
  }
};
export default TramitarCC;
